import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['María García', 'Carlos López', 'Ana Martínez', 'Pedro Sánchez', 'Laura Fernández', 'Javier Rodríguez', 'Carmen Díaz', 'Diego Moreno', 'Sofía Ruiz', 'Miguel Torres', 'Isabel Navarro', 'Pablo Jiménez', 'Elena Romero', 'Andrés Gil', 'Lucía Serrano'];
const CITIES = ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Málaga', 'Bilbao', 'Murcia', 'Alicante', 'Córdoba', 'Granada', 'Salamanca', 'Santander', 'Pamplona', 'Toledo'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      // Pick random name and city
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (8-15 seconds)
      const nextInterval = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showPopup, nextInterval);
    };
    // Initial start after a short delay
    const initialTimer = setTimeout(showPopup, 5000);
    return () => {
      clearTimeout(initialTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-385">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border-l-4 border-green-500 p-4 max-w-sm flex items-center space-x-3" data-id="element-386">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-387">
            <span className="text-xl" data-id="element-388">🛒</span>
          </div>
          <div data-id="element-389">
            <p className="text-sm text-gray-800 font-medium" data-id="element-390">
              <span className="font-bold" data-id="element-391">{currentData.name}</span> de{' '}
              {currentData.city} acaba de comprar el MegaPack
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-392">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}